export enum APPLICANT_LIST_COLUMNS_VALUES {
  NAMES = "names",
  EMAIL = "email",
  PADRON = "padron",
  DNI = "dni",
  STUDIES = "studies",
  STATE = "state",
  ACTIONS = "actions"
}

export const APPLICANT_LIST_COLUMNS = [
  APPLICANT_LIST_COLUMNS_VALUES.NAMES,
  APPLICANT_LIST_COLUMNS_VALUES.EMAIL,
  APPLICANT_LIST_COLUMNS_VALUES.PADRON,
  APPLICANT_LIST_COLUMNS_VALUES.DNI,
  APPLICANT_LIST_COLUMNS_VALUES.STUDIES,
  APPLICANT_LIST_COLUMNS_VALUES.STATE,
  APPLICANT_LIST_COLUMNS_VALUES.ACTIONS
];
